if (!window.mtPdpInit) {
  window.mtPdpInit = true;

  const strings = window.mtStrings || {};

  const reducedMq = window.mtReducedMq;
  const deskMq = window.matchMedia('(min-width: 750px)');
  const updaters = new Set();

  const runUpdaters = () => {
    updaters.forEach((update) => {
      if (!update()) updaters.delete(update);
    });
  };

  const readVariants = (root, selector) => {
    try {
      return JSON.parse(root.querySelector(selector).textContent);
    } catch {
      return [];
    }
  };

  const matchVariant = (variants, selected) =>
    variants.find((variant) =>
      selected.every((value, i) => value == null || variant.options[i] === value)
    );

  const valueAvailable = (variants, selected, optIndex, value) =>
    variants.some(
      (variant) =>
        variant.available &&
        variant.options[optIndex] === value &&
        selected.every((sel, i) => i === optIndex || sel == null || variant.options[i] === sel)
    );

  const readSelected = (root, selector, optKey, valueKey) => {
    const buttons = [...root.querySelectorAll(selector)];
    const count = buttons.reduce((max, button) => Math.max(max, Number(button.dataset[optKey]) + 1), 0);
    const selected = Array.from({ length: count }, () => null);
    buttons.forEach((button) => {
      if (button.getAttribute('aria-pressed') === 'true') {
        selected[Number(button.dataset[optKey])] = button.dataset[valueKey];
      }
    });
    return selected;
  };

  const initProduct = (root) => {
    const variants = readVariants(root, '[data-pdp-variants]');
    const track = root.querySelector('[data-pdp-track]');
    const colorOpt = root.dataset.pdpColorOpt == null ? -1 : Number(root.dataset.pdpColorOpt);
    const state = {
      variants,
      selected: readSelected(root, '[data-pdp-value]', 'pdpOpt', 'pdpValue'),
      qty: 1,
      interacted: false,
    };

    const syncGallery = () => {
      if (!track || colorOpt < 0) return false;
      const color = (state.selected[colorOpt] || '').toLowerCase();
      const slides = [...track.querySelectorAll('[data-pdp-color]')];
      const matched = slides.some((slide) => slide.dataset.pdpColor.toLowerCase() === color);
      slides.forEach((slide) => {
        slide.hidden = matched && slide.dataset.pdpColor !== '' && slide.dataset.pdpColor.toLowerCase() !== color;
      });
      return matched;
    };

    // When the newly picked color has no available variant for the currently
    // selected size, jump to the first available variant for this color.
    // If the whole color is sold out, leave the size selection as-is.
    const resolveColorFallback = () => {
      if (colorOpt < 0 || state.selected[colorOpt] == null) return;
      const current = matchVariant(state.variants, state.selected);
      if (current && current.available) return;
      const colorValue = state.selected[colorOpt];
      const candidates = state.variants.filter((variant) => variant.options[colorOpt] === colorValue);
      const availableVariant = candidates.find((variant) => variant.available);
      if (!availableVariant) return;
      availableVariant.options.forEach((value, index) => {
        if (index !== colorOpt) state.selected[index] = value;
      });
    };

    const syncLabels = () => {
      root.querySelectorAll('.mt-pdp__option').forEach((optionEl) => {
        const button = optionEl.querySelector('[data-pdp-value]');
        const label = optionEl.querySelector('.mt-pdp__label span');
        if (!button || !label) return;
        const optIndex = Number(button.dataset.pdpOpt);
        if (state.selected[optIndex] != null) label.textContent = state.selected[optIndex];
      });
    };

    const sync = () => {
      root.querySelectorAll('[data-pdp-value]').forEach((button) => {
        const optIndex = Number(button.dataset.pdpOpt);
        button.setAttribute('aria-pressed', String(state.selected[optIndex] === button.dataset.pdpValue));
        if (button.classList.contains('mt-pdp__pill')) {
          button.classList.toggle(
            'mt-pdp__pill--off',
            !valueAvailable(state.variants, state.selected, optIndex, button.dataset.pdpValue)
          );
        }
      });
      const variant = matchVariant(state.variants, state.selected);
      const adds = [...root.querySelectorAll('[data-pdp-add]')];
      if (!adds.length) return;
      adds.forEach((add) => {
        const addLabel = add.querySelector('[data-pdp-add-label]');
        const addPrice = add.querySelector('[data-pdp-add-price]');
        if (variant) {
          add.dataset.pdpVariant = variant.id;
          add.disabled = !variant.available;
          if (addLabel) addLabel.textContent = variant.available ? strings.addToCart : strings.soldOut;
          else add.textContent = variant.available ? strings.addToCart : strings.soldOut;
          if (addPrice) addPrice.innerHTML = variant.price;
        } else {
          add.disabled = true;
          if (addLabel) addLabel.textContent = strings.unavailable;
          else add.textContent = strings.unavailable;
        }
      });
      if (variant) {
        const price = root.querySelector('[data-pdp-price]');
        if (price) price.innerHTML = variant.price;
        const compare = root.querySelector('[data-pdp-compare]');
        if (compare) {
          compare.innerHTML = variant.compare || '';
          compare.hidden = !variant.compare;
        }
        const sku = root.querySelector('[data-pdp-sku]');
        if (sku) {
          sku.querySelector('[data-pdp-sku-value]').textContent = variant.sku || '';
          sku.hidden = !variant.sku;
        }
        if (state.interacted) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          try {
            history.replaceState(history.state, '', url);
          } catch {}
          const grouped = syncGallery();
          if (grouped && track && !deskMq.matches) {
            track.scrollTo({ left: 0, behavior: reducedMq.matches ? 'auto' : 'smooth' });
          } else if (!grouped && variant.media > 0 && track && !deskMq.matches) {
            const slide = track.querySelector(`[data-pdp-media="${variant.media}"]`);
            if (slide) {
              track.scrollTo({ left: slide.offsetLeft, behavior: reducedMq.matches ? 'auto' : 'smooth' });
            }
          }
          runUpdaters();
        }
      }
    };

    const arrows = () => {
      const prev = root.querySelector('[data-pdp-prev]');
      const next = root.querySelector('[data-pdp-next]');
      if (!prev || !next || !track) return;
      const update = () => {
        if (!track.isConnected) return false;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        return true;
      };
      const step = (dir) => {
        const slide = track.querySelector('.mt-pdp__slide');
        if (!slide) return;
        track.scrollBy({
          left: dir * (slide.offsetWidth + 5),
          behavior: reducedMq.matches ? 'auto' : 'smooth',
        });
      };
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, { passive: true });
      updaters.add(update);
      update();
    };

    root.addEventListener('click', (event) => {
      const value = event.target.closest('[data-pdp-value]');
      if (value) {
        state.interacted = true;
        const optIndex = Number(value.dataset.pdpOpt);
        state.selected[optIndex] = value.dataset.pdpValue;
        if (optIndex === colorOpt) resolveColorFallback();
        syncLabels();
        sync();
        return;
      }
      const tilesToggle = event.target.closest('[data-pdp-tiles-toggle]');
      if (tilesToggle) {
        const tiles = root.querySelector('[data-pdp-tiles]');
        const open = tilesToggle.getAttribute('aria-expanded') !== 'true';
        tilesToggle.setAttribute('aria-expanded', String(open));
        tiles?.classList.toggle('mt-pdp__tiles--collapsed', !open);
        tilesToggle.querySelector('[data-pdp-tiles-more]').hidden = open;
        tilesToggle.querySelector('[data-pdp-tiles-less]').hidden = !open;
        return;
      }
      const toggle = event.target.closest('[data-pdp-toggle]');
      if (toggle) {
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        panel?.classList.toggle('mt-open', open);
        if (open) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event_parameters: null });
          window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'select_content',
            event_parameters: {
              module_name: 'Product Details',
              content_name: toggle.dataset.contentName,
            },
          });
        }
        return;
      }
      const qtyEl = root.querySelector('[data-pdp-qty]');
      if (qtyEl && event.target.closest('[data-pdp-minus]')) {
        state.qty = Math.max(1, state.qty - 1);
        qtyEl.textContent = state.qty;
        return;
      }
      if (qtyEl && event.target.closest('[data-pdp-plus]')) {
        state.qty = Math.min(99, state.qty + 1);
        qtyEl.textContent = state.qty;
        return;
      }
      const add = event.target.closest('[data-pdp-add]');
      if (add) {
        const variant = matchVariant(state.variants, state.selected);
        const qty = state.qty;
        window.mtAddToCart(add, qty).then((added) => {
          if (!variant || !added) return;
          const finalItem = window.mtPricedAddItem(
            {
              item_id: variant.sku,
              item_name: root.dataset.itemName,
              ...(root.dataset.itemCategory ? { item_category: root.dataset.itemCategory } : {}),
              ...(variant.itemVariant ? { item_variant: variant.itemVariant } : {}),
              item_brand: root.dataset.itemBrand,
            },
            added,
            qty
          );
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event_parameters: null });
          window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'add_to_cart',
            event_parameters: {
              button_name: 'Add to Cart',
              currency: root.dataset.currency,
              value: +(finalItem.price * qty).toFixed(2),
              items: [finalItem],
            },
          });
        });
      }
    });

    const defaultColor = root.dataset.pdpDefaultColor;
    if (defaultColor) {
      const match = [...root.querySelectorAll('[data-pdp-tiles] [data-pdp-value]')].find(
        (button) => button.dataset.pdpValue === defaultColor
      );
      if (match) {
        state.selected[Number(match.dataset.pdpOpt)] = defaultColor;
      }
    }
    resolveColorFallback();
    syncLabels();

    const tiles = root.querySelector('[data-pdp-tiles]');
    const tilesToggle = root.querySelector('[data-pdp-tiles-toggle]');
    if (tiles && tilesToggle) {
      const update = () => {
        if (!tiles.isConnected) return false;
        if (tilesToggle.getAttribute('aria-expanded') !== 'true') {
          tiles.classList.add('mt-pdp__tiles--collapsed');
          tilesToggle.hidden = tiles.scrollHeight <= tiles.clientHeight + 1;
        }
        return true;
      };
      updaters.add(update);
      update();
    }

    syncGallery();
    if (variants.length) sync();
    arrows();
  };

  const initPair = (pair) => {
    const variants = readVariants(pair, '[data-pair-variants]');
    const state = { variants, selected: readSelected(pair, '[data-pair-value]', 'pairOpt', 'pairValue') };
    const colorSwatch = pair.querySelector('[data-pair-value].mt-pair__swatch');
    const colorOpt = colorSwatch ? Number(colorSwatch.dataset.pairOpt) : -1;

    // Same fallback as initProduct: if the current size has no available
    // variant for the newly picked color, jump to the first available one.
    const resolveColorFallback = () => {
      if (colorOpt < 0 || state.selected[colorOpt] == null) return;
      const current = matchVariant(state.variants, state.selected);
      if (current && current.available) return;
      const colorValue = state.selected[colorOpt];
      const candidates = state.variants.filter((variant) => variant.options[colorOpt] === colorValue);
      const availableVariant = candidates.find((variant) => variant.available);
      if (!availableVariant) return;
      availableVariant.options.forEach((value, index) => {
        if (index !== colorOpt) state.selected[index] = value;
      });
    };

    const sync = () => {
      pair.querySelectorAll('[data-pair-value]').forEach((button) => {
        const optIndex = Number(button.dataset.pairOpt);
        button.setAttribute('aria-pressed', String(state.selected[optIndex] === button.dataset.pairValue));
        if (button.classList.contains('mt-pair__pill')) {
          button.classList.toggle(
            'mt-pair__pill--off',
            !valueAvailable(state.variants, state.selected, optIndex, button.dataset.pairValue)
          );
        }
      });
      const variant = matchVariant(state.variants, state.selected);
      const add = pair.querySelector('[data-pair-add]');
      if (!add) return;
      if (variant) {
        add.dataset.pairVariant = variant.id;
        add.disabled = !variant.available;
        add.textContent = variant.available ? strings.addToCart : strings.soldOut;
        const image = pair.querySelector('.mt-pair__media img');
        if (variant.image && image && image.src !== variant.image) {
          image.srcset = '';
          image.src = variant.image;
        }
      } else {
        add.disabled = true;
        add.textContent = strings.unavailable;
      }
    };

    const pairGa4Item = () => {
      const variant = matchVariant(state.variants, state.selected);
      if (!variant || !pair.dataset.itemListId) return null;
      return {
        item_id: variant.sku,
        item_name: pair.dataset.itemName,
        discount: variant.discountValue || 0,
        index: +pair.dataset.itemIndex,
        item_list_id: pair.dataset.itemListId,
        item_list_name: pair.dataset.itemListName,
        ...(pair.dataset.itemCategory ? { item_category: pair.dataset.itemCategory } : {}),
        ...(variant.itemVariant ? { item_variant: variant.itemVariant } : {}),
        item_brand: pair.dataset.itemBrand,
        price: variant.priceValue,
        quantity: 1,
      };
    };

    pair.addEventListener('click', (event) => {
      const value = event.target.closest('[data-pair-value]');
      if (value) {
        const optIndex = Number(value.dataset.pairOpt);
        state.selected[optIndex] = value.dataset.pairValue;
        if (value.classList.contains('mt-pair__swatch')) {
          const name = pair.querySelector('[data-pair-color-name]');
          if (name) name.textContent = value.dataset.pairValue;
        }
        if (optIndex === colorOpt) resolveColorFallback();
        sync();
        return;
      }
      const add = event.target.closest('[data-pair-add]');
      if (add) {
        const item = pairGa4Item();
        const currency = pair.closest('[data-currency]')?.dataset.currency;
        window.mtAddToCart(add, 1).then((added) => {
          if (!item || !added) return;
          const finalItem = window.mtPricedAddItem(item, added, 1);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event_parameters: null });
          window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'add_to_cart',
            event_parameters: {
              button_name: 'Add to Cart',
              currency,
              value: finalItem.price,
              item_list_id: finalItem.item_list_id,
              item_list_name: finalItem.item_list_name,
              items: [finalItem],
            },
          });
        });
        return;
      }
      const details = event.target.closest('.mt-pair__details');
      if (details) {
        const item = pairGa4Item();
        if (item) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event_parameters: null });
          window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'select_item',
            event_parameters: {
              item_list_id: item.item_list_id,
              item_list_name: item.item_list_name,
              currency: pair.closest('[data-currency]')?.dataset.currency,
              button_name: 'See Details',
              items: [item],
            },
          });
        }
      }
    });

    resolveColorFallback();
    if (variants.length) sync();
  };

  const initPairs = (root) => {
    const wrap = root.querySelector('[data-pdp-pairs]');
    if (!wrap || !wrap.dataset.url) return;
    const load = async () => {
      const pool = [...wrap.querySelectorAll('[data-pdp-pairs-fallback] [data-pair]')];
      let doc = null;
      try {
        const res = await fetch(wrap.dataset.url);
        if (!res.ok) throw new Error(res.status);
        doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      } catch {
        doc = null;
      }
      if (!wrap.isConnected) return;
      const target = wrap.querySelector('[data-pdp-pairs-items]');
      if (!target) return;
      const fetched = doc ? [...doc.querySelectorAll('[data-pdp-pairs-items] [data-pair]')] : [];
      const keyOf = (pair) => pair.querySelector('.mt-pair__details')?.getAttribute('href')?.split('?')[0];
      const seen = new Set();
      const picks = [];
      for (const pair of [...fetched, ...pool]) {
        if (picks.length >= 2) break;
        const key = keyOf(pair);
        if (!key || seen.has(key)) continue;
        seen.add(key);
        picks.push(pair);
      }
      if (!picks.length) return;
      target.replaceChildren(...picks);
      wrap.hidden = false;
      picks.forEach(initPair);
      document.dispatchEvent(new CustomEvent('mt:reveal-scan'));
    };
    load();
  };

  const initSticky = (root) => {
    const cols = [...root.querySelectorAll('[data-pdp-col]')];
    if (!cols.length) return;
    const apply = () => {
      if (!cols[0].isConnected) {
        observer.disconnect();
        return false;
      }
      const header = document.querySelector('.mt-header');
      const headerH = header ? header.offsetHeight : 38;
      cols.forEach((col) => {
        if (!deskMq.matches) {
          col.style.removeProperty('--mt-stick');
          return;
        }
        const top = Math.min(headerH, window.innerHeight - col.offsetHeight);
        col.style.setProperty('--mt-stick', `${Math.round(top)}px`);
      });
      return true;
    };
    const observer = new ResizeObserver(apply);
    cols.forEach((col) => observer.observe(col));
    updaters.add(apply);
    apply();
  };

  const initStickyCta = (root) => {
    const ctas = root.querySelector('[data-pdp-ctas]');
    const sticky = root.querySelector('[data-pdp-sticky-cta]');
    if (!ctas || !sticky) return;
    const footer = document.querySelector('.mt-footer');
    const state = { pastCtas: false, atFooter: false };
    const sync = () => {
      sticky.classList.toggle('mt-is-visible', state.pastCtas && !state.atFooter);
    };
    const ctasObserver = new IntersectionObserver(([entry]) => {
      state.pastCtas = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sync();
    });
    ctasObserver.observe(ctas);
    if (footer) {
      const footerObserver = new IntersectionObserver(([entry]) => {
        state.atFooter = entry.isIntersecting;
        sync();
      });
      footerObserver.observe(footer);
    }
  };

  const initZoom = (root) => {
    const zoom = root.querySelector('[data-pdp-zoom]');
    const list = root.querySelector('[data-pdp-zoom-list]');
    const track = root.querySelector('[data-pdp-track]');
    if (!zoom || !list || !track) return;
    const prev = zoom.querySelector('[data-pdp-zoom-prev]');
    const next = zoom.querySelector('[data-pdp-zoom-next]');
    const closeBtn = zoom.querySelector('[data-pdp-zoom-close]');
    const buttons = [prev, closeBtn, next].filter(Boolean);
    let items = [];
    let trigger = null;
    let suppressClick = false;
    // Mouse click-to-zoom item (CSS 2x + transform-origin pan).
    let zoomed = null;
    // Touch pinch state: { item, img, s, x, y }, applied as an inline transform.
    let pinched = null;
    // Active pointers and the gesture they form: drag | pan | pinch.
    const pointers = new Map();
    let gesture = null;
    let lastTap = null;
    const MAX_SCALE = 3;

    const fineMq = window.matchMedia('(hover: hover) and (pointer: fine)');
    // Moving the transform-origin with the pointer pans the 2x image.
    const panTo = (event) => {
      const img = zoomed.querySelector('img');
      const rect = zoomed.getBoundingClientRect();
      const x = (event.clientX - rect.left - img.offsetLeft) / img.offsetWidth;
      const y = (event.clientY - rect.top - img.offsetTop) / img.offsetHeight;
      const pct = (value) => Math.min(Math.max(value, 0), 1) * 100;
      img.style.transformOrigin = `${pct(x)}% ${pct(y)}%`;
    };
    const paint = (state, animate) => {
      state.img.style.transition = animate ? '' : 'none';
      state.img.style.transform =
        state.s === 1 && !state.x && !state.y ? '' : `translate(${state.x}px, ${state.y}px) scale(${state.s})`;
    };
    // Untransformed centre of the image, in viewport coordinates.
    const centerOf = (state) => {
      const rect = state.item.getBoundingClientRect();
      return {
        x: rect.left + state.img.offsetLeft + state.img.offsetWidth / 2,
        y: rect.top + state.img.offsetTop + state.img.offsetHeight / 2,
      };
    };
    // How far the image may shift before its edge leaves the screen edge.
    const limits = (state, s) => ({
      x: Math.max(0, (state.img.offsetWidth * s - list.clientWidth) / 2),
      y: Math.max(0, (state.img.offsetHeight * s - list.clientHeight) / 2),
    });
    const clamp = (value, max) => Math.min(Math.max(value, -max), max);
    const pinchStateFor = (item) => {
      if (pinched?.item === item) return pinched;
      const img = item.querySelector('img');
      // Re-pick a sharper srcset candidate for the zoomed view.
      img.sizes = '100vw';
      return { item, img, s: 1, x: 0, y: 0 };
    };

    // Reset any zoom except the one on `keep`.
    const unzoom = (keep) => {
      if (zoomed && zoomed !== keep) {
        zoomed.classList.remove('mt-is-zoomed');
        zoomed = null;
      }
      if (pinched && pinched.item !== keep) {
        Object.assign(pinched, { s: 1, x: 0, y: 0 });
        paint(pinched, true);
        pinched = null;
      }
    };
    const toggleZoom = (item, event) => {
      if (zoomed === item) {
        unzoom();
        return;
      }
      unzoom();
      // Re-pick a sharper srcset candidate for the 2x view.
      item.querySelector('img').sizes = '100vw';
      zoomed = item;
      panTo(event);
      item.classList.add('mt-is-zoomed');
    };

    const currentIndex = () => Math.round(list.scrollLeft / list.clientWidth);
    const updateNav = () => {
      if (!gesture) unzoom(items[currentIndex()]);
      if (!prev || !next) return;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 1;
    };
    const goTo = (index, smooth) => {
      const item = items[Math.min(Math.max(index, 0), items.length - 1)];
      unzoom(item);
      if (!item) return;
      list.scrollTo({ left: item.offsetLeft, behavior: smooth && !reducedMq.matches ? 'smooth' : 'auto' });
    };

    const open = (slide) => {
      // Mirror the gallery's current color filter.
      zoom.querySelectorAll('[data-pdp-zoom-media]').forEach((item) => {
        const source = track.querySelector(`[data-pdp-media="${item.dataset.pdpZoomMedia}"]`);
        item.hidden = !source || source.hidden;
      });
      trigger = slide;
      zoom.hidden = false;
      document.documentElement.classList.add('mt-pdp-zoom-lock');
      items = [...zoom.querySelectorAll('[data-pdp-zoom-media]:not([hidden])')].sort(
        (a, b) => a.offsetLeft - b.offsetLeft
      );
      goTo(Math.max(0, items.findIndex((item) => item.dataset.pdpZoomMedia === slide.dataset.pdpMedia)), false);
      updateNav();
      requestAnimationFrame(() => zoom.classList.add('mt-is-open'));
      closeBtn.focus({ preventScroll: true });
    };
    const close = () => {
      if (zoom.hidden) return;
      unzoom();
      zoom.classList.remove('mt-is-open');
      zoom.hidden = true;
      document.documentElement.classList.remove('mt-pdp-zoom-lock');
      trigger?.focus({ preventScroll: true });
    };

    track.addEventListener('click', (event) => {
      const slide = event.target.closest('[data-pdp-media]');
      if (slide) open(slide);
    });
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const slide = event.target.closest('[data-pdp-media]');
      if (!slide) return;
      event.preventDefault();
      open(slide);
    });
    // Gestures. The viewer sets touch-action: none, so touch swipe, pinch and
    // pan are all handled here; trackpad/wheel scrolling stays native.
    //   drag  - one pointer, image at 1x: slides the carousel
    //   pan   - one finger on a pinched image: moves the image, and any
    //           movement past its edge spills over into the carousel
    //   pinch - two fingers: scales the current image around their midpoint
    const swallowClick = () => {
      suppressClick = true;
      setTimeout(() => {
        suppressClick = false;
      });
    };
    // A pinched image only hands off to the carousel when the gesture began
    // with the image already resting on that edge; reaching the edge mid-pan
    // just rubber-bands. dir > 0 = towards the next slide.
    const canSpill = (g, dir) => g.type !== 'pan' || (dir > 0 ? g.atNextEdge : g.atPrevEdge);
    const settleCarousel = (g) => {
      const shift = list.scrollLeft - g.left;
      if (!shift) {
        list.classList.remove('mt-is-dragging');
        return;
      }
      const dir = Math.sign(shift);
      const flick = Math.abs(g.vx) > 0.4 && Math.sign(-g.vx) === dir;
      const canTurn = canSpill(g, dir) && (Math.abs(shift) > list.clientWidth * 0.15 || flick);
      const release = () => list.classList.remove('mt-is-dragging');
      list.addEventListener('scrollend', release, { once: true });
      setTimeout(release, 600);
      goTo(canTurn ? g.index + dir : g.index, true);
    };
    const settlePinch = (g) => {
      const s = Math.min(Math.max(pinched.s, 1), MAX_SCALE);
      if (s !== pinched.s && s > 1) {
        // Over-pinched: shrink back around the last midpoint.
        pinched.x = g.m.x - g.c.x - s * g.lx;
        pinched.y = g.m.y - g.c.y - s * g.ly;
      }
      pinched.s = s;
      const lim = limits(pinched, s);
      pinched.x = s === 1 ? 0 : clamp(pinched.x, lim.x);
      pinched.y = s === 1 ? 0 : clamp(pinched.y, lim.y);
      paint(pinched, true);
      if (s === 1) pinched = null;
    };
    const toggleTapZoom = (point) => {
      const item = items[currentIndex()];
      if (!item) return;
      if (pinched?.item === item && pinched.s > 1) {
        Object.assign(pinched, { s: 1, x: 0, y: 0 });
        paint(pinched, true);
        pinched = null;
        return;
      }
      pinched = pinchStateFor(item);
      const c = centerOf(pinched);
      const lim = limits(pinched, 2);
      Object.assign(pinched, { s: 2, x: clamp(c.x - point.x, lim.x), y: clamp(c.y - point.y, lim.y) });
      paint(pinched, true);
    };

    const startGesture = () => {
      const pts = [...pointers.values()];
      const index = currentIndex();
      const item = items[index];
      if (!item) return;
      if (pts.length >= 2) {
        // Snap back any half-finished carousel drag before pinching.
        if (list.classList.contains('mt-is-dragging')) {
          list.scrollLeft = item.offsetLeft;
          list.classList.remove('mt-is-dragging');
        }
        pinched = pinchStateFor(item);
        const [a, b] = pts;
        const m = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        const c = centerOf(pinched);
        gesture = {
          type: 'pinch',
          d0: Math.hypot(a.x - b.x, a.y - b.y) || 1,
          s0: pinched.s,
          c,
          m,
          lx: (m.x - c.x - pinched.x) / pinched.s,
          ly: (m.y - c.y - pinched.y) / pinched.s,
        };
      } else if (pts.length === 1) {
        const p = pts[0];
        const panning = pinched?.item === item && pinched.s > 1;
        const lim = panning ? limits(pinched, pinched.s) : null;
        gesture = {
          type: panning ? 'pan' : 'drag',
          atNextEdge: panning && pinched.x <= -lim.x + 1,
          atPrevEdge: panning && pinched.x >= lim.x - 1,
          start: p,
          x0: pinched?.x || 0,
          y0: pinched?.y || 0,
          left: list.scrollLeft,
          index,
          moved: false,
          vx: 0,
          lastX: p.x,
          lastT: performance.now(),
        };
      }
    };

    list.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') {
        // A mouse-zoomed image follows the cursor instead of dragging.
        if (zoomed || event.button !== 0) return;
        pointers.clear();
      }
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      startGesture();
    });
    list.addEventListener('pointermove', (event) => {
      if (zoomed && event.pointerType === 'mouse') panTo(event);
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      const g = gesture;
      if (!g) return;

      if (g.type === 'pinch') {
        const [a, b] = [...pointers.values()];
        if (!b) return;
        g.m = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        const s = Math.min(Math.max((g.s0 * Math.hypot(a.x - b.x, a.y - b.y)) / g.d0, 0.75), MAX_SCALE * 1.5);
        Object.assign(pinched, { s, x: g.m.x - g.c.x - s * g.lx, y: g.m.y - g.c.y - s * g.ly });
        paint(pinched, false);
        return;
      }

      const dx = event.clientX - g.start.x;
      const dy = event.clientY - g.start.y;
      if (!g.moved) {
        if (Math.hypot(dx, dy) < 5) return;
        g.moved = true;
        if (event.pointerType === 'mouse') list.setPointerCapture(event.pointerId);
      }
      const now = performance.now();
      if (now > g.lastT) g.vx = (event.clientX - g.lastX) / (now - g.lastT);
      g.lastX = event.clientX;
      g.lastT = now;

      let spill = dx;
      if (g.type === 'pan') {
        const lim = limits(pinched, pinched.s);
        const x = g.x0 + dx;
        pinched.x = clamp(x, lim.x);
        pinched.y = clamp(g.y0 + dy, lim.y);
        paint(pinched, false);
        spill = x - pinched.x;
        if (!canSpill(g, -Math.sign(spill))) spill *= 0.25;
      }
      if (spill) list.classList.add('mt-is-dragging');
      list.scrollLeft = g.left - spill;
    });
    const endPointer = (event) => {
      if (!pointers.has(event.pointerId)) return;
      const point = pointers.get(event.pointerId);
      pointers.delete(event.pointerId);
      const g = gesture;
      gesture = null;
      if (g?.type === 'pinch') {
        swallowClick();
        settlePinch(g);
      } else if (g?.moved) {
        // Swallow the click that follows a drag so it can't close the viewer.
        swallowClick();
        settleCarousel(g);
      } else if (g && event.pointerType === 'touch' && event.target.closest('img')) {
        const now = performance.now();
        if (lastTap && now - lastTap.t < 300 && Math.hypot(point.x - lastTap.x, point.y - lastTap.y) < 30) {
          lastTap = null;
          toggleTapZoom(point);
        } else {
          lastTap = { t: now, x: point.x, y: point.y };
        }
      }
      // A finger lifted mid-pinch: carry on panning with the other one.
      if (pointers.size) startGesture();
    };
    list.addEventListener('pointerup', endPointer);
    list.addEventListener('pointercancel', endPointer);
    list.addEventListener('scroll', updateNav, { passive: true });
    // iOS Safari: stop the page-level pinch zoom behind the viewer.
    zoom.addEventListener('gesturestart', (event) => event.preventDefault());

    zoom.addEventListener('click', (event) => {
      if (suppressClick) {
        suppressClick = false;
        return;
      }
      if (event.target.closest('[data-pdp-zoom-close]')) {
        close();
      } else if (event.target.closest('[data-pdp-zoom-prev]')) {
        goTo(currentIndex() - 1, true);
      } else if (event.target.closest('[data-pdp-zoom-next]')) {
        goTo(currentIndex() + 1, true);
      } else if (event.target.closest('img')) {
        if (fineMq.matches) toggleZoom(event.target.closest('[data-pdp-zoom-media]'), event);
      } else {
        close();
      }
    });
    zoom.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(currentIndex() + (event.key === 'ArrowLeft' ? -1 : 1), true);
      } else if (event.key === 'Tab') {
        const enabled = buttons.filter((button) => !button.disabled);
        const first = enabled[0];
        const last = enabled[enabled.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-pdp]').forEach((root) => {
      if (root.dataset.mtReady) return;
      root.dataset.mtReady = 'true';
      initProduct(root);
      initZoom(root);
      initSticky(root);
      initStickyCta(root);
      initPairs(root);
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('resize', runUpdaters);
  deskMq.addEventListener('change', runUpdaters);

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    runUpdaters();
    document.querySelectorAll('[data-pdp-add], [data-pair-add]').forEach((button) => {
      if (button.textContent === strings.adding || button.textContent === strings.added) {
        const label = button.querySelector('[data-pdp-add-label]');
        if (label) label.textContent = strings.addToCart;
        else button.textContent = strings.addToCart;
        button.disabled = false;
      }
    });
  });
}
